import graphqlClient from './client';
import gql from 'graphql-tag';
import type { Candidate } from './types';

interface CandidateId {
  prospectId: string;
  candidateId: string;
}

export const query = gql`
  query CandidateById($id: CandidateId!) {
    candidateById(id: $id) {
      node {
        prospects {
          id
          candidateId
          mostRecentJobTitle
          mostRecentCompanyName
          mostRecentRoleMonths
          appliedDate
          bucket
          attachments {
            id
            type
            filename
            isPdf
          }
          source
          positionSummary {
            id
            title
            hasAccess
          }
        }
      }
    }
  }
`;

const fetchCandidateById = async (id: CandidateId): Promise<Candidate> => {
  const result = await graphqlClient.query({
    variables: { id },
    query,
  });

  const { node } = result.data.candidateById;

  return node as Candidate;
};

export default fetchCandidateById;
